import React, { useState, useEffect } from 'react';
import { Container } from 'react-bootstrap';
import { toast } from 'react-toastify';
import moment from 'moment';
import * as api from '~/Services/Service';
import HeaderAzul from '~/Components/HeaderAzul/HeaderAzul';
import Loading from '~/Components/Loading';
import FiltrosRelatorio from './FiltrosRelatorio';
import TabelaResultado from './TabelaResultado';

const RelatorioEstoqueContabil = () => {
  const [resultado, setResultado] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isExportando, setIsExportando] = useState(false);
  const [opcoesGes, setOpcoesGes] = useState([]);
  const [opcoesGruposGe, setOpcoesGruposGe] = useState([]);
  const [filtrosAtivos, setFiltrosAtivos] = useState(null);

  // Carga inicial de GEs e GruposGE (anti-race: LICOES ciclo 9 L3)
  useEffect(() => {
    let ativo = true;
    const carregarOpcoes = async () => {
      try {
        const [ges, grupos] = await Promise.all([
          api.estImobObterGes(),
          api.estImobObterGruposGe(),
        ]);
        if (!ativo) return;
        setOpcoesGes(Array.isArray(ges) ? ges : []);
        setOpcoesGruposGe(Array.isArray(grupos) ? grupos : []);
      } catch (err) {
        if (!ativo) return;
        const msg =
          err && err.message ? err.message : 'Erro ao carregar opções de filtro.';
        toast.error(msg);
      }
    };
    carregarOpcoes();
    return () => {
      ativo = false;
    };
  }, []);

  const handleSubmit = async (filtros) => {
    setIsLoading(true);
    setResultado(null);
    setFiltrosAtivos(filtros);
    try {
      const res = await api.estImobConsultar(filtros);
      setResultado(res);
    } catch (err) {
      const msg =
        err && err.message
          ? err.message
          : 'Erro ao consultar relatório. Tente novamente.';
      toast.error(msg);
    } finally {
      setIsLoading(false);
    }
  };

  const handleExportarExcel = async () => {
    if (!filtrosAtivos) return;
    setIsExportando(true);
    try {
      const blob = await api.estImobExportarExcel(filtrosAtivos);
      const url = window.URL.createObjectURL(new Blob([blob]));
      const link = document.createElement('a');
      link.href = url;
      const dataHora = moment().format('YYYY-MM-DD_HHmmss');
      link.setAttribute('download', `EstoqueImob_${dataHora}.xlsx`);
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (err) {
      const msg =
        err && err.message ? err.message : 'Erro ao exportar Excel.';
      toast.error(msg);
    } finally {
      setIsExportando(false);
    }
  };

  return (
    <Container fluid className="px-3 py-3">
      <HeaderAzul title="Estoque Disponível — Contábil Imob" />

      <FiltrosRelatorio
        onSubmit={handleSubmit}
        isLoading={isLoading}
        opcoesGes={opcoesGes}
        opcoesGruposGe={opcoesGruposGe}
      />

      {isLoading && <Loading label="Gerando relatório..." />}

      {!isLoading && (
        <TabelaResultado
          resultado={resultado}
          onExportarExcel={handleExportarExcel}
          isExportando={isExportando}
        />
      )}
    </Container>
  );
};

export default RelatorioEstoqueContabil;
